import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApigeeService } from '../apigee/apigee.service';
import { HttpClient } from '@angular/common/http';
import { AccessManagerCfgService } from './accessManagerCfg.service';

@Injectable({
  providedIn: 'root'
})
export class GestorService {

  constructor(
    private httpClient: HttpClient,
    private accessManagerCfgService: AccessManagerCfgService,
    private apigeeService: ApigeeService) { }

  /**
   * Obtiene los roles del trabajador desde gestor y los almacena en cache
   * @returns Observable con los roles del trabajador
   */
  getRolesApi(): Observable<string[]> {
    const cfg = this.accessManagerCfgService.getCfg();
    const url = `${cfg.gestorEndpoint}/roles/worker`;

    const fiscalDocNumber = this.apigeeService.userInfo.nameid;

    let body = {
      FiscalDocNumber: fiscalDocNumber
    };

    return this.httpClient.post<any[]>(url, body);
  }
}
